module.exports = __webpack_public_path__ + "static/media/4.32409ea4.jpeg";